import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { selectFeatureFlags } from 'core/userContext';
import { useBillingQueryContext } from '../../contexts';
import {
  USERS,
  USERS_ADDED,
  ACTIVE_USERS,
  ACTIVE_USERS_ADDED,
  CURRENT_USERS,
} from '../../constants';
import { SimpleIndexPage } from '../SimpleIndexPage/SimpleIndexPage';
import { createColumns, createRows, queryByFn } from '../../utils';
import { PageActions } from './PageActions';
import { createRowCell } from './TableCell';

export const TEXT = {
  PAGE_TITLE: 'Users usage',
};

export const UsersUsage = () => {
  const { AllowActiveUsersMetricInBilling } = useSelector(selectFeatureFlags);
  const { projectIds, pickManyProjectMetrics, pickManyOrgMetrics, isLoading } =
    useBillingQueryContext();
  const { search } = useLocation();

  useEffect(() => {
    window.scrollTo();
  }, []);

  const metricNames = [
    CURRENT_USERS,
    USERS,
    USERS_ADDED,
    ...(AllowActiveUsersMetricInBilling ? [ACTIVE_USERS, ACTIVE_USERS_ADDED] : []),
  ];

  const orgMetrics = pickManyOrgMetrics(metricNames);
  const metricsByProjectId = projectIds.reduce(
    (acc, projectId) => ({
      [projectId]: pickManyProjectMetrics(projectId, metricNames),
      ...acc,
    }),
    {},
  );

  const rows = createRows(orgMetrics, metricsByProjectId);
  const columns = createColumns(metricsByProjectId);

  return (
    <SimpleIndexPage
      rows={rows}
      columns={columns}
      createRowCell={createRowCell}
      breadcrumb={{
        content: 'Usage and Billing',
        href: `/payments/info${search}`,
      }}
      pageTitle={TEXT.PAGE_TITLE}
      pageActions={<PageActions />}
      isLoading={isLoading}
      queryByFn={queryByFn}
    />
  );
};
